var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGameBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100",
    width: "100px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x37_"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x38_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8,87.9H69.2c-0.8,0-1.5-0.7-1.5-1.5c-0.1-7.8-6.6-14.1-14.4-14.1c-7.8,0-14.2,6.3-14.4,14.1c0,0.8-0.7,1.5-1.5,1.5   H24.1c-0.8,0-1.5-0.7-1.5-1.5V72.6c-8.9-0.8-15.9-8.2-15.9-17.3s7-16.6,15.9-17.3V25.8c0-0.8,0.7-1.5,1.5-1.5H36   c0.8-8.9,8.2-15.9,17.3-15.9s16.6,7,17.3,15.9h14.1c0.8,0,1.5,0.7,1.5,1.5v60.6C86.3,87.2,85.6,87.9,84.8,87.9z M70.6,84.9h12.6   V27.3h-14c-0.8,0-1.5-0.7-1.5-1.5c0-7.9-6.5-14.4-14.4-14.4S39,17.9,39,25.8c0,0.8-0.7,1.5-1.5,1.5H25.6v12.1   c0,0.8-0.7,1.5-1.5,1.5c-7.9,0-14.4,6.5-14.4,14.4s6.5,14.4,14.4,14.4c0.8,0,1.5,0.7,1.5,1.5v13.7h10.4c0.9-8.7,8.4-15.6,17.3-15.6   C62.3,69.3,69.7,76.2,70.6,84.9z M74.9,41c-2.7,0-4.9-2.2-4.9-4.9c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9   C79.8,38.8,77.6,41,74.9,41z M74.9,34.2c-1.1,0-1.9,0.9-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9C76.8,35,76,34.2,74.9,34.2z   "
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x39_"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_1"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_3"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_5"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_7"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_8"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_9"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_0"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_1"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_2"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_3"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameBook);
export default __webpack_public_path__ + "static/media/gameBook.3bdfe59660e7dbda1e63660868fff9bf.svg";
export { ForwardRef as ReactComponent };